export default __webpack_public_path__ + "list-dark.e0f92593.svg";